export const BETA_PROMPT_COOKIES = {
  DISMISSED_PREFIX: 'ZRM_BETA_UPSELL_DISMISSED_',
  EXPIRATION: 30,
};
